import { Injectable } from '@angular/core';
import {
  Actions,
  createEffect,
  CreateEffectMetadata,
  ofType,
} from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { ClientService } from '../api/client.service';
import {
  ArztEinschreibungActionTypes,
  ArztEinschreibungenPageLoadedAction,
  getArztEinschreibungFeatureState,
  LastArztEinschreibungenPageLoadedAction,
  LoadArztEinschreibungenPageAction,
  LoadingArztEinschreibungenPageAction,
  RefreshArztEinschreibungenAction,
} from './arzt-einschreibungen.reducer';

@Injectable()
export class ArztEinschreibungenEffects {
  // Effects
  // noinspection JSUnusedGlobalSymbols
  fetchEinschreibungen$: Observable<ArztEinschreibungenPageLoadedAction> &
    CreateEffectMetadata;

  // noinspection JSUnusedGlobalSymbols
  refreshEinschreibungen$: Observable<LoadArztEinschreibungenPageAction> &
    CreateEffectMetadata;

  constructor(
    private actions$: Actions,
    private store: Store,
    private vvClient: ClientService,
  ) {
    // Effects

    // noinspection JSUnusedGlobalSymbols
    this.fetchEinschreibungen$ = createEffect(() =>
      this.actions$.pipe(
        ofType<LoadArztEinschreibungenPageAction>(
          ArztEinschreibungActionTypes.LoadArztEinschreibungen,
        ),
        withLatestFrom(this.store.select(getArztEinschreibungFeatureState)),
        filter(([r, s]) => {
          if (r.options?.force) {
            return true;
          }
          if (r.options?.patientPk) {
            const patientBekannt =
              s.arztEinschreibungen.einschreibungenFuerPatienten[
                r.options?.patientPk
              ] !== undefined;
            return !patientBekannt; // patient noch nicht geladen;
          }
          return true;
        }),
        map(([r]) => {
          this.store.dispatch(
            new LoadingArztEinschreibungenPageAction(
              r.page,
              r.pageSize,
              r.ordering,
              r.options,
            ),
          );
          return r;
        }),
        mergeMap((r) =>
          this.vvClient
            .getEinschreibungen(r.page, r.pageSize, r.ordering, r.options)
            .pipe(
              map((p) => {
                if (p.next) {
                  this.store.dispatch(
                    new LoadArztEinschreibungenPageAction(
                      p.pageNumber + 1,
                      p.pageSize,
                      p.ordering,
                      {
                        ...r.options,
                        force: true,
                      },
                    ),
                  );
                } else {
                  this.store.dispatch(
                    new LastArztEinschreibungenPageLoadedAction(
                      p.pageNumber,
                      p.pageSize,
                      p.ordering,
                      r.options,
                    ),
                  );
                }
                return p;
              }),
              map((s) => new ArztEinschreibungenPageLoadedAction(s, r.options)),
              catchError(() => EMPTY),
            ),
        ),
      ),
    );

    // noinspection JSUnusedGlobalSymbols
    this.refreshEinschreibungen$ = createEffect(() =>
      this.actions$.pipe(
        ofType<RefreshArztEinschreibungenAction>(
          ArztEinschreibungActionTypes.RefreshArztEinschreibungen,
        ),
        map(
          (r) =>
            new LoadArztEinschreibungenPageAction(1, 10, null, {
              ...r.options,
              force: true,
            }),
        ),
      ),
    );
  }
}
